import { DetailAssessmentConstants } from './constants';

export const isObjectEmpty = (object: any) => {
    for (const prop in object) {
        if (Object.hasOwn(object, prop)) {
            return false;
        }
    }
    return true;
};

export const getCountryFromLanguage = (language: string) => {
    const country = language.split('-')[1];
    return country;
};

export const getPersona = () => {
    if (window && window.env && window.env.USER) {
        const allPermissions = window.env.USER.permissions;
        const personaRelatedPermissions = allPermissions.filter((permission: string) => permission.endsWith('_PERSONA'));
        if (personaRelatedPermissions.includes(DetailAssessmentConstants.DETAIL_ASSESSMENT_PERSONA)) {
            return DetailAssessmentConstants.DETAIL_ASSESSMENT_PERSONA;
        }
    }
};
